import {useListView} from '../../core/ListViewProvider'
import {DriverListToolbar} from './DriverListToolbar'
import {DriversListGrouping} from './DriversListGrouping'

const DriversListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <DriversListGrouping /> : <DriverListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {DriversListHeader}
